<template>
  <div class="error-bubble">
    <div class="error-text">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M17.5 12.821C17.6989 12.821 17.8897 12.742 18.0303 12.6013C18.171 12.4607 18.25 12.2699 18.25 12.071C18.25 11.8721 18.171 11.6813 18.0303 11.5407C17.8897 11.4 17.6989 11.321 17.5 11.321V12.821ZM5.5 11.321C5.30109 11.321 5.11032 11.4 4.96967 11.5407C4.82902 11.6813 4.75 11.8721 4.75 12.071C4.75 12.2699 4.82902 12.4607 4.96967 12.6013C5.11032 12.742 5.30109 12.821 5.5 12.821V11.321ZM20.75 12C20.75 14.4533 19.7754 16.806 18.0407 18.5407C16.306 20.2754 13.9533 21.25 11.5 21.25V22.75C17.437 22.75 22.25 17.937 22.25 12H20.75ZM11.5 21.25C9.04675 21.25 6.69397 20.2754 4.95926 18.5407C3.22455 16.806 2.25 14.4533 2.25 12H0.75C0.75 17.937 5.563 22.75 11.5 22.75V21.25ZM2.25 12C2.25 9.54675 3.22455 7.19397 4.95926 5.45926C6.69397 3.72455 9.04675 2.75 11.5 2.75V1.25C5.563 1.25 0.75 6.063 0.75 12H2.25ZM11.5 2.75C13.9533 2.75 16.306 3.72455 18.0407 5.45926C19.7754 7.19397 20.75 9.54675 20.75 12H22.25C22.25 6.063 17.437 1.25 11.5 1.25V2.75ZM17.5 11.321H5.5V12.821H17.5V11.321Z" fill="#F4502F"/>
      </svg>
      <span>{{ this.errorMessage }}</span>
    </div>
    <button type="button" class="close-button" @click="closeErrorBubble">
      {{ this.$translations.buttons.refresh }}
    </button>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  props: [
    'errorMessage',
  ],
  emits: ['closeError'],
  methods: {
    closeErrorBubble() {
      this.$emit('closeError');
      window.location.reload();
    }
  }
}
</script>
